import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'
import { injectIntl, FormattedMessage } from 'react-intl'
import KanBoIcon from 'components/KanBoIcon'
import SmartCard from 'components/SmartCard'
import sweetalert from 'sweetalert2'
import { withBoardPermission } from 'dataProviders/Board'

export class SubCard extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,

    permission: PropTypes.object.isRequired,

    cardId: PropTypes.number.isRequired,
    parentId: PropTypes.number.isRequired,
    isCardArchived: PropTypes.bool.isRequired,

    requestRemoveCardParent: PropTypes.func.isRequired,

    sortable: PropTypes.object.isRequired
  }

  handleRemoveClick = () => {
    const {
      intl,

      cardId,
      parentId,

      requestRemoveCardParent
    } = this.props

    sweetalert({
      text: intl.formatMessage({ id: 'SUBCARD_DETACH_QUESTION' }),
      confirmButtonText: intl.formatMessage({ id: 'DETACH' }),
      cancelButtonText: intl.formatMessage({ id: 'CANCEL' }),
      showCancelButton: true,
      type: 'warning'
    }).then(() => {
      requestRemoveCardParent({
        cardId,
        parentId
      })
    }, () => {})
  }

  render () {
    const {
      cardId,
      permission,
      isCardArchived,

      sortable
    } = this.props

    const menu = (!isCardArchived && permission.member) ? [{
      icon: <KanBoIcon fixedWidth name='kanbo-16-remove' />,
      title: <FormattedMessage id='DETACH' />,
      onClick: this.handleRemoveClick
    }] : null

    return (
      <SmartCard
        ref={(ref) => {
          const node = findDOMNode(ref)
          sortable.connectDropTarget(node)
          sortable.connectDragSource(node)
        }}
        id={cardId}
        isDragging={sortable.isDragging}
        menu={menu}
      />
    )
  }
}

export default injectIntl(withBoardPermission(SubCard), { forwardRef: true })
